import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { LabelsPipe } from '@fuse/pipes/labels/labels.pipe';
import { PalantirLabelColors } from '../../../../@fuse/pipes/labels/labels.type';

@Component({
  selector: 'palantir-tag',
  templateUrl: './palantir-tag.component.html',
  styleUrls: ['./palantir-tag.component.scss'],
  providers: [LabelsPipe]
})

export class PalantirTagComponent implements OnInit {
  @Input() color: PalantirLabelColors;
  @Input() size: 'base' | 'lg' | 'xs' = 'base';
  @Input() style: 'bold' | 'soft' = 'soft';
  @Input() shape: 'default' | 'rounded' = 'rounded';
  @Input() activatable = false;
  @Input() minified = false;
  @Input() badge = false;

  constructor(
    private labels: LabelsPipe,
    private host: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    this.host.nativeElement.style.setProperty('--palantir-tag-color', this.labels.transform(this.color).color);
  }
}
